import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MACHINES } from "../data/machines";

const fetchMachines = async () => {
  const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/machines`);
  return res.data?.machines?.length ? res.data.machines : MACHINES;
};

export const useMachines = () =>
  useQuery({
    queryKey: ["machines"],
    queryFn: fetchMachines,
    initialData: MACHINES,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });